import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormArray, FormGroup, AbstractControl, FormBuilder } from '@angular/forms';
import { Observable, throwError, merge, EMPTY } from 'rxjs';
import { map, distinct, mapTo, catchError, retry } from 'rxjs/operators';

import { Event, Partner } from '@app/shared/_models/common';
import { Sales_order } from '@app/shared/_models/sales';

import { LoginService } from '@app/common/login.service';
import * as constants from "@app/shared/constants";

import { environment } from '@app/../environments/environment';

const headers = { 'content-type': 'application/json' };

@Injectable({
  providedIn: 'root'
})
export class PrintService {

  constructor(public loginService: LoginService, private http: HttpClient) { }
  
  postPrintEvent(objecttyp: number, objectid: number, data: any): Observable<any> {
	  console.log("postPrintEvent");
	  let event:Event = {
		  id: 0, 
		  typ: constants.EventType.PRINT,					// 4: Print
			userid: this.loginService.loggeduser?.id,
		  objecttyp: objecttyp,		
		  objectid: objectid,
		  data: data,
	  }
	  return this.http.post<any>(environment.server_url + "/event", event, { 'headers': headers });
  }  

  // Le serveur range dans c_attach chaque DEVIS imprimé, le BC non (sales/src/order/print.rs, trade_doc_pdf) ; HttpClient porte le jeton, un window.open sortirait une 401.
  getOrderDoc$(orderId: number, doc: constants.TradeDoc): Observable<Blob> {
    return this.http.get(environment.server_url + '/sales/order/' + orderId + '/' + doc, { responseType: 'blob' });
  }

  // Pas un GET pur : le serveur rend la pièce scellée à chaque appel et compte l'impression au JET (get_order_justificatif, sales/src/order/routes.rs).
  // `docRef` choisit la pièce quand la commande en a plusieurs (une facture par BL) ; absent, la dernière pièce scellée de la commande.
  getOrderJustificatif$(orderId: number, formatImpression: String, docRef?: string): Observable<Blob> {
    const piece = docRef ? '?doc_ref=' + encodeURIComponent(docRef) : '';
    return this.http.get(environment.server_url + '/sales/order/' + orderId + '/justificatif/' + formatImpression + piece, { responseType: 'blob' });
  }

  // Lance le flux d'impression du navigateur sur un PDF, via un iframe caché : pas de nouvelle
  // fenêtre, donc rien à débloquer côté pop-ups. Même chemin que le bon de livraison signé.
  printPdf(blob: Blob): void {
    const pdf = blob.type === 'application/pdf' ? blob : new Blob([blob], { type: 'application/pdf' });
    const url = URL.createObjectURL(pdf);

    const iframe = document.createElement('iframe');
    iframe.setAttribute('aria-hidden', 'true');
    // Hors-écran mais avec une taille réelle (A4 ~96 dpi) : sinon le viewer PDF de Chrome ne
    // s'initialise pas et print() reste sans effet.
    iframe.style.cssText = 'position:fixed; left:-10000px; top:0; width:794px; height:1123px; border:0;';

    let removed = false;
    const cleanup = () => { if (!removed) { removed = true; iframe.remove(); URL.revokeObjectURL(url); } };

    iframe.onload = () => {
      const win = iframe.contentWindow;
      if (!win) { cleanup(); return; }
      win.addEventListener('afterprint', cleanup);   // retire l'iframe une fois l'impression terminée ou annulée
      setTimeout(() => { win.focus(); win.print(); }, 50);
      setTimeout(cleanup, 60000);                    // filet de sécurité si 'afterprint' ne se déclenche pas
    };

    iframe.src = url;
    document.body.appendChild(iframe);
  }
}
